/* unplugin-vue-components disabled */import { render } from "./QuizViewerLayout.vue?vue&type=template&id=0d0967fd&scoped=true&ts=true"
import script from "./QuizViewerLayout.vue?vue&type=script&lang=ts"
export * from "./QuizViewerLayout.vue?vue&type=script&lang=ts"

import "./QuizViewerLayout.vue?vue&type=style&index=0&id=0d0967fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0967fd"]])

export default __exports__